import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import { UserCouponResponse } from '@models/coupon';
import { CouponStatusKr } from '@models/coupon/extension';

import styles from './styles.module.scss';

interface Props {
    coupon: UserCouponResponse;
}

function CouponInfo({ coupon }:Props) {
  const {
    availableShops,
    couponName,
    discountMethod,
    discountValue,
    imageUrl,
    status,
  } = coupon;
  return (
        <Column className={styles.container}
                align='center' >
            <div className={styles.card}>
                <div className={styles.image}>
                    <Image src={imageUrl}
                           width={124}
                           height={124}
                           alt='쿠폰' />
                    {status !== 'ISSUED' && (
                        <div className={styles.disabled}>
                            <Text size='s' fontWeight='bold' color={colors.gray7} align='center'>
                                {CouponStatusKr[status]}
                            </Text>
                        </div>
                    )}
                </div>
            </div>
            <TextUnderline>
                <Text size='xl' fontWeight='bold' color={colors.gray6}>
                    {availableShops === 'ALL_SHOPS' ? '전체 매장 사용 가능' : availableShops}
                </Text>
            </TextUnderline>
            <Text fontWeight='bold' color={colors.gray8}
                  size='3xl'
                  className={styles.name} >
                {couponName}
            </Text>
            <Row spacing={8}>
                {/* <Text color={colors.gray8}>1개</Text> */}
                <Text size='xl' fontWeight='bold' color={colors.red} >
                    {discountValue.toLocaleString()}{discountMethod === 'RATE' ? '%' : '원'}
                </Text>
            </Row>
        </Column>
  );
}

export default CouponInfo;
